module.exports = __webpack_public_path__ + "img/whatsapp.bd4b47ce.png";